import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';


@Component({
  selector: 'app-measure-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
  ],
  templateUrl: './measure-form.component.html',
  styleUrl: './measure-form.component.scss',
})
export class MeasureFormComponent {
  @Input() id: number | string = 0;
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);

  public saveForm: FormGroup = new FormGroup({});

  public showModalImage = false

  public dropdowns: any = {}

  public showOptionalFields = false;

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();

    if (this.id != 0) {
      this.getById(this.id);
    }
  }

  acceptFormFunction() {
    this.saveEntity()
  }

  closeFormFunction() {
    this.closeFunction.emit();
  }

  createForm() {
    this.saveForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      short_name: new FormControl('', [Validators.required]),
      description: new FormControl(null),
    })
  }

  toggleOptionalFields() {
    this.showOptionalFields = !this.showOptionalFields;
  }

  getById(id: number | string) {
    this.loading.set(true);
    this.apiService.getById(Urls.urls.measurements, id).subscribe({
      next: (data: any) => {
        this.saveForm.patchValue(data.measurement);
        this.loading.set(false);

        this.showOptionalFields = true;

        this.cdr.detectChanges();
      },
      error: (error: any) => {
        console.error('ERROR obtener productos. ' + error);
        this.loading.set(false);
      },
      complete: () => {
        this.loading.set(false);
      },
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);

      this.apiService.save(Urls.urls.measurements, this.saveForm.value, this.id).subscribe({
        next: (response: any) => {
          Utils.notification.success("Medida guardada")
          this.acceptFunction.emit(response);
          this.closeFormFunction()
        },
        error: (error: any) => {
          this.saving.set(false);
          Utils.notification.alert(Utils.extractErrorMessage(error) || "Error al guardar la medida")
        },
        complete: () => {
          this.saving.set(false);
        }
      })
    } else {
      Utils.notification.alert("Debe completar todos los campos obligatorios")
    }
  }

}
